'use client'

import { styled } from 'styled-components'

export const CultureListBoxWrapper = styled.section`
    display.: block;
    width : 1000px;
    margin : 0 auto 40px;

    @media all and (max-width : 1050px) {
        width : 100%;
        padding : 0 20px;
    }
`;

export const SearchWrapper = styled.div`
    max-width : calc(500px - 40px);
    margin-bottom : 30px;
`